import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Price, PriceV2} from '../../../types/Price';

export const OriginalPrice: FC<{
  price: Price | PriceV2;
  className?: string;
}> = ({price, className}) => {
  if ('finalPrice' in price && price.original) {
    return (
      <OriginalPriceWrapper
        className={className}
        data-testid="originalPrice"
        dangerouslySetInnerHTML={{__html: price.original.text}}
      />
    );
  }

  return null;
};

export const OriginalPriceWrapper = styled.div`
  font-size: ${FONT_SIZES.px9};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 150%;
  color: ${COLORS['Text.Grey']};
  display: flex;
`;
